import classes from "./Description.module.css";

export default function Description({ brandDescription }) {
  return <div className={classes.text}>{brandDescription}</div>;
}
